import enUS from './en-US'
import zhCN from './zh-CN'
import zhTW from './zh-TW'

export default {
  'en-US': enUS,
  'zh-CN': zhCN,
  'zh-TW': zhTW
}
